export function typesenseServerConfig({ path = null, additionalHeaders = {} } = {}) {

  return {
    // The gateway replaces this required SDK placeholder with a server-side key.
    apiKey: "gateway-managed",
    nodes: [
      {
        host: window.location.hostname,
        port: window.location.port || (window.location.protocol === "https:" ? "443" : "80"),
        protocol: window.location.protocol.replace(":", ""),
        ...(path && { path }),
      },
    ],
    connectionTimeoutSeconds: 10,
    numRetries: 4,
    additionalHeaders,
  };
}

export const searchConfig = typesenseServerConfig();

export const dictionaryConfig = typesenseServerConfig({ path: "/search_dictionary" });
